// extracted by mini-css-extract-plugin
module.exports = {"icon":"_02712f2b3b--icon--u7322","logo":"_02712f2b3b--logo--lZMfA"};